import { jsx, jsxs } from "react/jsx-runtime";
import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ActionSelector from "./actionSelector/ActionSelector";
import KeyedComponent from "./keyed/keyedComponent";
import TerminalComponent from "./terminal/terminalComponent";
import EcheckComponent from "./echeck/echeckComponent";
export default function Terminal({
  onFormChange = () => {
  },
  title: titleOverride,
  paymentMethod,
  isSaveCard,
  vaultedCard,
  vaultedEcheck
}) {
  const title = titleOverride || (isSaveCard ? "Add New Card" : "New Payment");
  const [keyedComponentKey, setKeyedComponentKey] = useState(0);
  const [echeckComponentKey, setEcheckComponentKey] = useState(0);
  const prevVaultedCardRef = useRef(vaultedCard);
  const prevVaultedEcheckRef = useRef(vaultedEcheck);
  useEffect(() => {
    if (prevVaultedCardRef.current !== vaultedCard) {
      setKeyedComponentKey((k) => k + 1);
      prevVaultedCardRef.current = vaultedCard;
    }
  }, [vaultedCard]);
  useEffect(() => {
    if (prevVaultedEcheckRef.current !== vaultedEcheck) {
      setEcheckComponentKey((k) => k + 1);
      prevVaultedEcheckRef.current = vaultedEcheck;
    }
  }, [vaultedEcheck]);
  const renderAction = () => {
    if (paymentMethod === "TERMINAL") {
      return /* @__PURE__ */ jsx(TerminalComponent, { onFormChange });
    } else if (paymentMethod === "ECHECK" || paymentMethod === "VAULT" && vaultedEcheck) {
      return /* @__PURE__ */ jsx(EcheckComponent, { onFormChange }, echeckComponentKey);
    }
    return /* @__PURE__ */ jsx(KeyedComponent, { onFormChange }, keyedComponentKey);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: "iframeTitle", children: title }),
    /* @__PURE__ */ jsxs("div", { className: "form", children: [
      /* @__PURE__ */ jsx(ActionSelector, { onFormChange }),
      renderAction()
    ] })
  ] });
}
Terminal.propTypes = {
  onFormChange: PropTypes.func,
  title: PropTypes.string,
  paymentMethod: PropTypes.string.isRequired,
  isSaveCard: PropTypes.bool,
  vaultedCard: PropTypes.any,
  vaultedEcheck: PropTypes.any
};
Terminal.defaultProps = {
  isSaveCard: false
};
